import axios from '../axios'

// コース詳細（モジュール/教材/クイズ/お知らせ + 自分の完了モジュールID）
const getCourseApi = async (courseId) => {
  return await axios.get(`api/lms/courses/${courseId}`)
}

export default getCourseApi
